<div id="{{id}}" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-center">{{ 'MODAL.NEED_HELP_TITLE' | translate }}</h4>
        @if (!cssDisabled) {
          <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        }
      </div>
      <div class="modal-body">
        @if (!screenShotInfoShown) {
          <div>
            <p [innerHTML]="'MODAL.NEED_HELP' | translate"></p>
            <button id="btnShowInfo" type="button" class="btn-link" (click)="showScreenShotInfo()">
              {{ 'MODAL.HOW_SCREENSHOT' | translate }}
            </button>
          </div>
        }

        @if (screenShotInfoShown) {
          <div>
            <p [innerHTML]= "'MODAL.SCREENSHOT_HELP' | translate"></p>
          </div>
        }
      </div>
      <div class="modal-footer">
        @if (screenShotInfoShown) {
          <div class="col-12 col-lg-4 m-0 p-2" [ngClass]="{ 'col-md-6' : screenShotInfoShown }">
            <button id="btnBack" type="button" class="btn w-100 d-block btn-default" (click)="showHelpInfo()">
              <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </button>
          </div>
        }
        <div class="col-12 col-lg-4 m-0 p-2 ms-auto"
          [ngClass]="{ 'col-md-6' : screenShotInfoShown, 'me-auto' : !screenShotInfoShown }">
          @if (!cssDisabled) {
            <button type="button" class="btn w-100 d-block btn-primary" data-bs-dismiss="modal" (click)="reset()">Close</button>
          }
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->